import React from "react";
import { getRuntimeSafetyReport } from "../../services/local/runtimeEnvironment";

const blockedPageStyles = {
  minHeight: "100vh",
  display: "grid",
  placeItems: "center",
  padding: "32px",
  backgroundColor: "#fff7ed",
  color: "#111827",
  fontFamily: "Arial, sans-serif",
};

const blockedPanelStyles = {
  width: "min(620px, 100%)",
  padding: "28px",
  border: "2px solid #f97316",
  borderRadius: "8px",
  backgroundColor: "#ffffff",
  boxShadow: "0 20px 50px rgba(15, 23, 42, 0.14)",
};

const betaBadgeStyles = {
  position: "fixed",
  top: "8px",
  left: "50%",
  zIndex: 2147483647,
  transform: "translateX(-50%)",
  padding: "8px 14px",
  border: "2px solid #9a3412",
  borderRadius: "6px",
  backgroundColor: "#ffedd5",
  color: "#7c2d12",
  boxShadow: "0 8px 20px rgba(124, 45, 18, 0.18)",
  fontFamily: "Arial, sans-serif",
  fontSize: "13px",
  fontWeight: 800,
  letterSpacing: 0,
  lineHeight: 1,
  pointerEvents: "none",
};

function RuntimeEnvironmentGate({ children }) {
  const report = getRuntimeSafetyReport();

  if (!report.isSafe) {
    return (
      <main style={blockedPageStyles}>
        <section style={blockedPanelStyles}>
          <p
            style={{
              margin: "0 0 8px",
              color: "#c2410c",
              fontSize: "13px",
              fontWeight: 800,
            }}
          >
            BLOQUEO DE SEGURIDAD
          </p>
          <h1 style={{ margin: "0 0 14px", fontSize: "28px" }}>
            Este entorno no puede operar
          </h1>
          <p style={{ margin: "0 0 18px", lineHeight: 1.55 }}>
            MozzoApp detuvo la aplicacion para evitar que una prueba modifique
            pedidos, pagos o stock reales.
          </p>
          <ul style={{ margin: 0, paddingLeft: "22px", lineHeight: 1.55 }}>
            {report.reasons.map((reason) => (
              <li key={reason}>{reason}</li>
            ))}
          </ul>
        </section>
      </main>
    );
  }

  return (
    <>
      {report.runtimeEnvironment === "beta" ? (
        <div
          className="runtime-environment-beta-badge"
          style={betaBadgeStyles}
          role="status"
          aria-live="polite"
        >
          BETA | ENTORNO DE PRUEBAS
        </div>
      ) : null}
      {children}
    </>
  );
}

export default RuntimeEnvironmentGate;
